<template>
  <figure
    class="overflow-hidden bg-gray-100 flex-shrink-0 flex justify-center items-center mb-3 rounded dark:bg-gray-800 dark:text-white dark:border dark:border-gray-800"
    :class="{ 'aspect-w-1 aspect-h-1': !image }"
  >
    <!-- Image -->
    <img
      v-if="image"
      class="w-full h-full object-contain"
      :src="image"
      :alt="alt"
      loading="lazy"
    />

    <!-- Fallback -->
    <div v-else class="w-1/3 h-1/3 m-auto">
      <Icon class="text-gray-300 dark:text-gray-700" name="IcTwotoneImage" />
    </div>
  </figure>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    alt: { type: String, default: null },
    size: {
      type: String,
      default: "200x200",
    },
  },
  computed: {
    image() {
      return this.value?.find((item) =>
        (item.mimetype || "image").startsWith("image")
      )?.size?.[`_${this.size}`];
    },
  },
};
</script>
